import { createContext, Dispatch, useReducer } from "react";
import { ITechnologyAction } from "Interfaces/TechnologyActions";
import { TechnologyReducer } from "Reducers";
import { TTechnologyState } from "Types/TTechnologyState";

// Initial main state of the app at the start
const initialTechnologyState: TTechnologyState = {
    counts: {
        magPatentCount: 0,
        magScienceCount: 0,
        patentArticleCount: 0,
        requirementCount: 0,
        technologyHighlightsCount: 0,
        webArticleCount: 0,
        partnerCount: 0,
        supplierCount: 0
    }
};

// Context is created using React’s createContext() hook. 
// Passing a default state and dispatch function here isn't necessary 
// since it is set after by the provider.
// But we do it anyway for better code auto-completion in the IDE.
export const TechnologyContext = createContext<{
    technologyState: TTechnologyState;
    technologyDispatch: Dispatch<ITechnologyAction>;
}>({
    technologyState: initialTechnologyState,
    technologyDispatch: () => null
});

export const TechnologyStore = ({ children }: any) => {
    // When using hook,
    // we get access to 2 values:
    // - a current state,
    // - and a dispatch function.
    // useReducer takes 2 parameters:
    // - the state reducer,
    // - and an initial state
    const [technologyState, technologyDispatch] = useReducer(TechnologyReducer, initialTechnologyState);

    return (
        <TechnologyContext.Provider value={ { technologyState, technologyDispatch } }>
            { children }
        </TechnologyContext.Provider>
    );
};
